import { useFormContext } from "react-hook-form";
import { Grid } from "@mui/material";
import { BorderedFormGrid } from "../../Forms/BorderedFormGrid";
import Odc from "../Odc";
import { UPPERCASE_INPUT } from "../../Forms/formStyles";
import { TextFieldInput } from "../../Forms/TextFieldInput";
import { MdmFormProps } from "../../Forms/MdmFormProps";

export function OdcGsdbForm({ disabledFields }: MdmFormProps) {
  const { control } = useFormContext<Odc>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput
          name="Gsdb"
          control={control}
          label="GSDB"
          required
          disabledFields={disabledFields}
          inputProps={UPPERCASE_INPUT}
        />
      </Grid>
    </BorderedFormGrid>
  );
}
